import React from "react";
import Modal from "../../Elements/Modal/Modal";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import "./EsimCheckModal.css";

const EsimCheckModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Check eSIM compatibility"
      actions={
        <>
          <SecondButton onClick={onClose}>Close</SecondButton>
        </>
      }
    >
      <div className="esim-check-modal-body">
        <p className="esim-check-text">1. Open the dialer on your phone.</p>
        <p className="esim-check-text">
          2. Dial <strong>*#06#</strong>.
        </p>
        <p className="esim-check-text">
          3. If you see an <strong>EID</strong> number, your device supports eSIM.
        </p>
        <p className="esim-check-hint text-muted">
          If there is no EID shown, your device is most likely not eSIM‑compatible.
        </p>
      </div>
    </Modal>
  );
};

export default EsimCheckModal;
